var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddSmallicon = function SvgAddSmallicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4 7.6v.8a.4.4 0 0 1-.4.4H8.8V13a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4V8.8H3a.4.4 0 0 1-.4-.4v-.8c0-.221.18-.4.4-.4h4.2V3c0-.221.18-.4.4-.4h.8c.221 0 .4.179.4.4v4.2H13c.221 0 .4.179.4.4Z"
  })));
};
export default SvgAddSmallicon;